import http from '@/plugins/http';

export default (jobIds, subStatus, canceledReason) => new Promise((res, rej) => {
  http.patch('/v3/customers/jobs/cancel_multiple', {
    jobs: jobIds,
    sub_status: subStatus,
    canceled_reason: canceledReason,
  })
    .then((response) => {
      res(response.data);
    })
    .catch((error) => {
      rej(error);
    });
});
